import { createContext, useContext } from 'react';
import { defaultWhiteLabelling } from 'components-stateless/constants';
import type { ThemeConfig } from './ThemeConfig';

/**
 * @deprecated use Theme from '@mui/material'
 */
const ThemeContext = createContext({
  ...defaultWhiteLabelling,
  allowWhitelabelling: false,
});

export const useThemeContext = (): ThemeConfig => useContext(ThemeContext);

export default ThemeContext;
